import { maxUint16 } from '../../constants/number.js';
export const gasPerPubdataDefault = 50000n;
export const maxBytecodeSize = maxUint16 * 32n;
export const requiredL1ToL2GasPerPubdataLimit = 800n;
//# sourceMappingURL=number.js.map